/** The seven hues of the content palette, each at two weights. */
export type SwatchHue = 'purple' | 'blue' | 'green' | 'teal' | 'yellow' | 'red' | 'grey'

export type SwatchWeight = 'light' | 'dark'

export type SwatchColor = `${SwatchHue}-${SwatchWeight}`

export const SWATCH_HUES: readonly SwatchHue[] = [
  'purple',
  'blue',
  'green',
  'teal',
  'yellow',
  'red',
  'grey',
]

export const SWATCH_COLORS: readonly SwatchColor[] = [
  ...SWATCH_HUES.map((hue) => `${hue}-light` as SwatchColor),
  ...SWATCH_HUES.map((hue) => `${hue}-dark` as SwatchColor),
]

export const SWATCH_DEFAULT: SwatchColor = 'purple-light'

export type SwatchSize = 'default' | 'lg' | 'xs'

/** Reads as a sentence when a screen reader lands on the control. */
export const swatchLabel = (color: SwatchColor): string => {
  const [hue, weight] = color.split('-')
  return `${weight === 'dark' ? 'Dark' : 'Light'} ${hue}`
}
